import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { OrderDetail } from '../../shared/models/OrderDetail';
import { Quote} from '../../shared/models/Quote';
import { OrderHistory } from '../../shared/models/OrderHistory';
import { PagingResults } from '../../shared/models/PagingResult';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { ReportParameter, ReportRequestObject } from '../../shared/models/ReportRequestObject';
import { HttpResponse } from '@angular/common/http';
import { QuoteDetail } from '../../shared/models/QuoteDetail';
import { QuoteReport } from '../../shared/models/QuoteReport';
import { Territory } from '../../shared/models/Territory';
import { Fee } from '../../shared/models/Fee';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit, OnDestroy {
  readonly Page: string = "Quotes";
  QuoteList: Quote[];
  DistList: Distributor[];
  DistSubscription: Subscription;
  CurrentDist: Distributor;
  QuoteSortValue: string;
  HideDist: boolean;
  CurrQuoteDetails: OrderDetail[];
  CurUser: User;
  FilterList: FilterObject[];
  CustFilter: FilterObject;
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  hideLoadingModal: boolean;
  constructor(private global: GlobalService, private http: HttpService, private router: Router) { }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.CurUser = new User();
    this.QuoteSortValue = "orderdate";
    this.PageIndex = 0;
    this.PageSize = 20;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;

      
      
      if (!this.CurUser || this.CurUser == null) {
        this.router.navigate(['/']);
      }

      if (this.CurUser.IsTolomaticUser) {
        this.HideDist = false;
      }
      else {
        this.HideDist = true;
      }

      this.CustFilter = new FilterObject();
      this.CustFilter.Key = "customer";

      this.http.GetDistributors().then(x => {
        if (x.StatusCode == "200") {
          this.DistList = x.Content;
          this.global.getCurrentDist().then(dist => {
            this.http.PostUserActivity(this.CurUser.UserId.toString(), "Quotes", "Load", "", this.CurUser.IsTolomaticUser ? dist.CompanyId : this.CurUser.DistributorId);

            if (dist) {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId == dist.CompanyId) {
                this.CurrentDist = dist;
              }
              else if (this.CurUser.IsTolomaticUser) {
                this.CurrentDist = dist;
              }
              else {
                this.CurrentDist = this.CurUser.Distributor;
              }
            }
            else {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId != "") {
                this.CurrentDist = this.CurUser.Distributor;
              } else {
                this.CurrentDist = this.DistList[0];
              }
            }

            this.CustFilter.Value = this.CurrentDist.CompanyId;
            this.FilterList = [];
            this.FilterList.push(this.CustFilter);
            this.LoadQuotes();
          });
          
        }

      });
    });

    this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
      debugger;
      if (dist && dist.CompanyId != this.CurrentDist.CompanyId) {
        this.CurrentDist = dist;
        this.CustFilter.Value = this.CurrentDist.CompanyId;
        this.LoadQuotes();
      }
    });
  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }
  }

  LoadQuotes() {
    this.hideLoadingModal = false;
    this.http.GetQuotes(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize,this.QuoteSortValue).then(x => {
      if (x.StatusCode == "200") {
        var results = <PagingResults>x.Content;
        this.QuoteList = results.Items;
        this.ItemCount = results.ItemCount;
        this.QuoteList.forEach(x => {
          x.ShortShipTo = x.ShipToName;
          if (x.ShortShipTo.length > 30) {
            x.ShortShipTo = x.ShortShipTo.substring(0, 27) + "...";
          }
        });
      }
      this.hideLoadingModal = true;
    });
  }

  LoadDetails(custOrder:Quote) {
    if (!custOrder.QuoteDetails) {
      this.hideLoadingModal = false;
      this.http.GetQuoteDetails(custOrder.QuoteNumber, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          var details = <QuoteDetail[]>x.Content;
          custOrder.QuoteDetails = [];
          details.forEach(x => {
            x.ShortDesc = x.Description;
            if (x.ShortDesc.length > 55) {
              x.ShortDesc = x.ShortDesc.substring(0, 52) + "...";
            }
            custOrder.QuoteDetails.push(new QuoteDetail().BuildFromExisting(x,custOrder.IsV2));
          });          
        }
        this.hideLoadingModal = true;
      });
    }
  }

  OpenQuote(quote: Quote) {
    if (quote.IsV2) {
      if (!quote.QuoteDetails) {
        this.http.GetQuoteDetails(quote.QuoteNumber, this.CurUser.UserId.toString()).then(x => {
          if (x.StatusCode == "200") {
            var details = <QuoteDetail[]>x.Content;
            quote.QuoteDetails = [];
            details.forEach(x => {
              x.ShortDesc = x.Description;
              if (x.ShortDesc.length > 55) {
                x.ShortDesc = x.ShortDesc.substring(0, 52) + "...";
              }
              quote.QuoteDetails.push(new QuoteDetail().BuildFromExisting(x, quote.IsV2));
            });
          }
          this.router.navigate(['/editquote'], { state: { CurrentQuote: quote } });
        });
      }
      else {
        this.router.navigate(['/editquote'], { state: { CurrentQuote: quote } });
      }
      
    }
    
  }

  Dist_Change(event: any) {
    //this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.global.setCurrentDist(newDist);
  }

  QuoteSort_Change(event: any) {
    this.QuoteSortValue = event.value;
    this.LoadQuotes();
  }

  FollowOrder(follow: boolean, orderNum: string) {

  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadQuotes();
  }

  SubscribeToUpdates(orderNumber: string) {

  }

  async GetQuoteReport(quote: Quote) {
    this.hideLoadingModal = false;
    if (quote.IsV2) {
      var qr = new QuoteReport();
      var Terr = new Territory();
      await this.http.GetTerritories().then(x => {
        Terr = (<Territory[]>x.Content).filter(x => x.TerritoryCode == quote.TerritoryCode)[0];
      });

      await this.http.GetQuoteDetails(quote.QuoteNumber, this.CurUser.UserId.toString()).then(x => {
        quote.QuoteDetails = <QuoteDetail[]>x.Content;
        quote.QuoteDetails.forEach(d => {
          d = new QuoteDetail().BuildFromExisting(d, true);
        });
      });
      await this.http.GetQuoteFees(quote.QuoteRowPointer).then(x => {
        quote.QuoteFees = <Fee[]>x.Content;
      });
      qr.CreateQuoteReport(quote, quote.CustomerName, Terr.TerritoryName, quote.Salesman,this.CurrentDist.CustType);
      this.hideLoadingModal = true;
    }
    else {
      var reportRequest = new ReportRequestObject();
      reportRequest.ReportPath = "/SLReports/_TOL_QuoteReport_NonSL";
      var estStarting = new ReportParameter();
      estStarting.Key = "EstimateStarting";
      estStarting.Value = quote.QuoteNumber;
      var estEnding = new ReportParameter();
      estEnding.Key = "EstimateEnding";
      estEnding.Value = quote.QuoteNumber;
      var dist = this.global.getCurrentDist();
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "Quotes", "Quote Report", quote.QuoteNumber, this.CurUser.IsTolomaticUser ? this.CurrentDist.CompanyId : this.CurUser.DistributorId);
      reportRequest.ReportParams.push(estStarting);
      reportRequest.ReportParams.push(estEnding);

      this.http.GetSQLReport(reportRequest).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = quote.QuoteNumber + ".pdf";
        a.click();
        this.hideLoadingModal = true;
      });
    }
  }

  CreateNewQuote() {
    this.router.navigate(['/editquote']);
  }


}
